import HeadComponent from '@/core/components/Head/HeadComponent';

export default HeadComponent;
